import { Modal, Space, Spin, Typography } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { MassActionTypeModal } from '@app/components/Modals';
import { PREFIX } from '@app/constants/appPrefix';
import { TagsPickerModal } from '@app/shared/components';
import { divideAmount } from '@app/utils';

import { ClientsTable, useClientsList } from '@pages/Clients';
import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { Filters } from '@pages/Clients/NewClientsList/ui/Filters';

import '@pages/Clients/ClientsList/styles/ClientsList.desktop.scss';
import '@pages/Clients/ClientsList/styles/ClientsList.tablet.scss';
import '@pages/Clients/ClientsList/styles/ClientsList.mobile.scss';

export const ClientsList = () => {
  const {
    rowSelection,
    totalRowsCount,
    isArchivingModalOpen,
    selectionCount,
    hasRightToEdit,
    tagsModal,
    tagsLoader,
    isTagsLoading,
    availableTags,
    selectedTagsIds,
    isResetModal,
    hasUserRightForModuleView,
    setSelectedTagsIds,
    closeTagsModal,
    addTags,
    removeTags,
    action,
    setResetModal,
    handleEdit,
    handlePageChange,
    deleteRows,
    setIsArchivingModalOpen,
    resetAll,
    isMobile,
    MassActionButton,
    pageNumber,
    hasUserRightToCommunicate,
    isMassActionTypeModalOpen,
    onCloseMassActionTypeModal,
    onConfirmMassActionType,
    actionType,
    showMassActionTypeLoading,
    disabledSelectedItemsActions,
    renderSendMessageModal,
  } = useClientsList();

  const { clientsData, isTableLoading, serverFilter } =
    useNewClientsListContext();

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div
      className={`${PREFIX}clients-list`}
      style={{
        position: 'relative',
      }}
    >
      <Space
        className="page-container full-width"
        size="large"
        direction="vertical"
      >
        <Filters />
        <div className="clients-count-container">
          <Typography.Text className="records-count" type="secondary">
            {`Выбрано ${selectionCount} из ${
              clientsData?.CountClients
                ? divideAmount(clientsData?.CountClients || 0)
                : 0
            } клиентов`}
          </Typography.Text>
          {MassActionButton}
        </div>
        <div className="table-container">
          <div
            className="loader-container"
            data-loading={showMassActionTypeLoading}
          >
            <div className="spinner-container">
              <Spin spinning={true} size="large" />
              <Typography.Text>
                Применяется массовое действие ко всем клиентам. Это может занять
                некоторое время
              </Typography.Text>
            </div>
          </div>
          <ClientsTable
            isMobile={isMobile}
            isStartedPackData={false}
            loader={isTableLoading}
            data={clientsData?.Clients || []}
            rowSelection={rowSelection}
            rowsPerPage={serverFilter.ClientsPerPage}
            totalRowsCount={clientsData?.CountClients || 0}
            hasRightToEdit={hasRightToEdit}
            handlePageChange={handlePageChange}
            handleEdit={handleEdit}
            pageNumber={pageNumber}
            hasUserRightToCommunicate={hasUserRightToCommunicate}
          />
        </div>

        {!isMobile && MassActionButton}
      </Space>
      <Modal
        title={`Удалить из базы ${
          actionType === 'all' ? 'всех' : 'выбранных'
        } клиентов ${actionType === 'selected' ? `(${selectionCount})` : ''}`}
        open={isArchivingModalOpen}
        cancelText="Отмена"
        okText="В архив"
        okType="danger"
        onOk={deleteRows}
        okButtonProps={{
          type: 'primary',
        }}
        onCancel={() => setIsArchivingModalOpen(false)}
      >
        <p>
          Вы уверены, что хотите удалить из базы{' '}
          {actionType === 'all' ? 'всех' : 'выбранных'} клиентов{' '}
          {actionType === 'selected' ? `(${selectionCount})` : ''}?
        </p>
      </Modal>

      <TagsPickerModal
        title={action === 'removeTags' ? 'Убрать теги' : 'Добавить теги'}
        open={tagsModal}
        okText={action === 'removeTags' ? 'Убрать' : 'Сохранить'}
        availableTags={availableTags}
        selectedTagIds={selectedTagsIds}
        isTagsLoading={isTagsLoading}
        isSaving={tagsLoader}
        isConfirmDisabled={selectedTagsIds.length === 0}
        onSelectedTagIdsChange={setSelectedTagsIds}
        onConfirm={action === 'removeTags' ? removeTags : addTags}
        onCancel={closeTagsModal}
      />

      <Modal
        title="Уведомление"
        open={isResetModal}
        onOk={resetAll}
        onCancel={() => setResetModal(false)}
      >
        <p>Вы уверены, что хотите сбросить все настроенные фильтры?</p>
      </Modal>
      <MassActionTypeModal
        isOpen={isMassActionTypeModalOpen}
        onClose={onCloseMassActionTypeModal}
        onConfirm={onConfirmMassActionType}
        disabledSelectedItemsActions={disabledSelectedItemsActions}
        type="clients"
        selectedCount={selectionCount}
        allCount={totalRowsCount}
      />
      {renderSendMessageModal()}
    </div>
  );
};
